<template>
    <div :class="applyFormGroupClass">
        <div id="changelocation" class="add-float-labels-yantr input-group">
            <label>{{ label }}</label>
            <zip-code-input
                ref="geoInput"
                v-model="ZipCode"
                :autofocus="true"
                @input="getLocationByZip"
            />
            <span v-if="ShowZipCodeError" id="zipCodeError" class="error-msg">{{ errorMessage }}</span>
        </div>
    </div>
</template>

<script>
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import StringFormat from '~/helpers/string-format';

    export default {
        props: {
            showZipCode: {
                default: false,
            },
            applyFormGroupClass: {
                default: 'form-group',
            },
            zipCode: {
                default: '',
            },
            locationData: {
                default() {
                    return {};
                },
            },
            isZipCodeValid: {
                default: false,
            },
            label: {
                default: false,
            },
        },
        data() {
            return {
                ShowZipCode: this.showZipCode,
                ZipCode: this.zipCode,
                LocationData: this.locationData,
                IsZipCodeValid: this.isZipCodeValid,
                ShowZipCodeError: false,
                errorMessage: 'Please enter a valid zip code.',
            };
        },
        methods: {
            submitZip() {
                if (this.LocationData && this.IsZipCodeValid) {
                    this.updateLocation(this.LocationData);
                } else {
                    this.IsZipCodeValid = false;
                }
            },
            updateLocation(val) {
                val.city = StringFormat.capitalize(val.city);
                this.$emit('input', val);
                this.ZipCode = val.zipCode;
            },
            getLocationByZip() {
                if (this.zipCodeValidator() && this.ZipCode.length > 4) {
                    this.GetZipCode(
                        this.ZipCode,
                        this.checkLocationResponse,
                    );
                    setTimeout(() => {
                        this.submitZip();
                    }, 1000);
                } else {
                    this.IsZipCodeValid = false;
                    this.ShowZipCodeError = this.IsZipCodeValid;
                }
            },
            zipCodeValidator() {
                const zipCodeRegEx = /^\d{5}(?:[-\s]\d{4})?$/;
                if (this.zipCode === '') {
                    this.$refs.geoInput.$el.setAttribute('aria-invalid', 'false');
                }
                return zipCodeRegEx.test(this.ZipCode) && this.ZipCode !== '';
            },
            checkLocationResponse(val) {
                if (val.city) {
                    this.LocationData = val;
                    this.IsZipCodeValid = true;
                    this.ShowZipCodeError = !this.IsZipCodeValid;
                    this.$refs.geoInput.$el.setAttribute('aria-invalid', 'false');
                } else {
                    this.IsZipCodeValid = false;
                    this.ShowZipCodeError = !this.IsZipCodeValid;
                    this.$refs.geoInput.$el.setAttribute('aria-invalid', 'true');
                }
            },
        },
        watch: {
            zipCode() {
                this.ZipCode = this.zipCode;
            },
            showZipCode() {
                this.ShowZipCode = this.showZipCode;
            },
            LocationData(newLocationData) {
                if (newLocationData) {
                    this.updateLocation(newLocationData);
                }
            },
        },
        components: {
            ZipCodeInput,
        },
        mixins: [GetLocation],
    };
</script>
<style scoped lang="scss">
#changelocation {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
        span#zipCodeError {
        color: #d93551;
        }
}
</style>
